import { render, staticRenderFns } from "./sloganSVG.vue?vue&type=template&id=71bf03bc&scoped=true&"
import script from "./sloganSVG.vue?vue&type=script&lang=js&"
export * from "./sloganSVG.vue?vue&type=script&lang=js&"
import style0 from "./sloganSVG.vue?vue&type=style&index=0&id=71bf03bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf03bc",
  null
  
)

export default component.exports